<template>
    <div>
        <div class="accordion" id="accordionExample" v-if="showItems.length > 0">
            <div class="card">
                <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                        <button class="no-border text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                           {{ $translate('Klettershop5::Template.zusammenkaufen') }}
                        </button>
                    </h2>
                </div>

                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body">
                        <div class="combisell">
                            <ul class="list-unstyled list-inline">
                                <template v-if="loading === true">
                                    <div class="d-block text-center w-100" >
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <template v-if="showItems">
                                        <template v-for="(item,index) in showItems">
                                            <li class="list-inline-item px-2">
                                                <a :href="'/'+item.data.texts.urlPath+'/a-'+item.data.item.id+'/'">
                                                    <template v-if="item.data.images.variation.length > 0">
                                                        <img :src="item.data.images.variation[0].urlMiddle" class="img-fluid">
                                                    </template>
                                                    <template v-else>
                                                        <img :src="item.data.images.all[0].urlMiddle" class="img-fluid">
                                                    </template>
                                                </a>
                                            </li>
                                            <template v-if="index < showItems.length-1">
                                                <li class="list-inline-item  px-2"><i class="fa fa-plus"></i></li>
                                            </template>
                                            <template v-if="(index+1) == showItems.length">
                                                <div class="text-center">
                                                    {{ $translate('Klettershop5::Template.priceall') }}  <b>{{ pricesAll | currency }}</b><br>
                                                    <button class="btn btn-default ml-lg-3 mt-3" @click="buyItems()" :disabled="waiting">
                                                        {{ $translate('Klettershop5::Template.buyall') }} <i class="fa fa-circle-o-notch fa-spin fa-fw" v-if="waiting"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </ul>
                        </div>
                        <template v-if="showItems">
                            <ul class="list-unstyled mt-3">
                                <template v-for="(item,index) in showItems">
                                    <li>
                                        <input type="checkbox" :checked="item.active" @click="toggleActive(item)">
                                        <a :href="'/'+item.data.texts.urlPath+'/a-'+item.data.item.id+'/'" :class="{ 'text-stroke text-muted' : item.active == false }" target="_blank">{{ item.data.texts.name1 }}</a>
                                        <span class="font-weight-bold ml-3">
                                            {{ item.data.prices.default.price.value | currency }}
                                        </span>
                                    </li>
                                </template>
                            </ul>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>>

<script>
    export default
    {
        props: ['template'],
        data: function()
        {
            return{
                items:[],
                waiting:false,
                loading:false,
                priceAll:0
            }
        },
        mounted()
        {
            this.getCrossSellers(ceresStore.getters.currentItemVariation);
        },
        created()
        {
            vueEventHub.$on("varChanged", variante =>
            {
                this.items = [];
                this.getCrossSellers(variante);
            });
        },
        methods:
            {
                //Accessory
                toggleActive:function(item)
                {
                    if(item.active == true)
                    {
                        item.active = false
                    }
                    else
                    {
                        item.active = true;
                    }
                },
                getCrossSellers:function(variation)
                {

                    let _self       = this;
                    _self.loading = true;
                    let variations = [];

                    if(variation.hasOwnProperty('variationProperties'))
                    {
                        for(let i = 0; i < variation.variationProperties.length; i++ )
                        {
                            if(variation.variationProperties[i].id === 7)
                            {
                                for(let i2 = 0; i2 < variation.variationProperties[i].properties.length; i2++)
                                {
                                    if(variation.variationProperties[i].properties[i2].id === 31)
                                    {

                                        variations = variation.variationProperties[i].properties[i2].values.value.split(",").map(function(item) {
                                            return parseInt(item, 10);
                                        });
                                    }
                                }
                            }
                        }
                    }
                    if(variations.length > 0)
                    {
                        $.ajax(
                        {
                            type: 'POST',
                            url: '/crossseller/variations/',
                            data:{'items':variations },
                            success: function (response)
                            {

                                if(response.length > 0)
                                {
                                    for(let i = 0; i < response.length; i++)
                                    {
                                        response[i].active = true
                                        _self.items.push(response[i]);
                                    }
                                    _self.items.unshift(
                                        {
                                            active:true,
                                            data:ceresStore.getters.currentItemVariation,
                                            id:ceresStore.getters.currentItemVariation.variation.id
                                        })
                                }
                                _self.loading = false;
                            },
                            error: function (jqXHR, textStatus, errorThrown)
                            {
                                console.log(jqXHR);
                            }
                        });
                    }
                },
                buyItems:function()
                {
                    let items = this.items;
                    let _self = this;
                    _self.waiting = true;

                    var variations = [];
                    for (var i = 0; i < items.length; i++) {
                        if(items[i].active == true)
                        {
                            variations.push(
                                {
                                    "variationId": items[i].id,
                                    "quantity": 1,
                                    "name": items[i].data.texts.name1
                                });
                        }
                    }
                    var data =
                        {
                            "items": variations
                        }
                    $.ajax({
                        type: 'POST',
                        url: '/crossseller/buy/',
                        data: data,
                        success: function (data) {
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].error) {
                                    CeresNotification.error(ceresTranslate("Klettershop5::Template.notesNichtgenugbestand",
                                        {
                                            variationName: data[i].error.variationName,
                                            stock: data[i].error.placeholder.stock
                                        })
                                    );
                                } else {
                                    CeresNotification.success(ceresTranslate("Klettershop5::Template.notesArtikelhinzugefuegt")).closeAfter(3000);
                                }
                                if (i === data.length - 1) {
                                    vueApp.$store.commit("setBasketItems", data[i].basketItems);
                                    vueApp.$store.commit("setBasket", data[i].basket);
                                }
                            }
                            _self.waiting = false;
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.log(jqXHR);
                        }
                    })
                }
            },
        computed:
            {
                pricesAll:function()
                {
                    let prices = 0;
                    for(let i = 0; i < this.items.length; i++)
                    {
                        if(this.items[i].active == true)
                        {
                            prices = prices + this.items[i].data.prices.default.price.value
                        }
                    }
                    this.priceAll = prices
                    return prices;
                },
                showItems: function()
                {
                    return this.items;
                }
            }
    }
</script>
